import { queryOptions } from '@tanstack/react-query';
import {
  MessagingSendersService,
  type SenderAvailabilityQuery,
} from 'src/api/generated';

/**
 * Shares tenant-scoped availability evidence between sender choices and send guards.
 * @param tenantId - Effective authenticated or support tenant.
 * @param params - Sender identity, preferring its stable provider ID.
 * @param enabled - Whether real provider availability should be checked.
 * @returns Query options compatible with existing connection refreshes.
 */
export const senderAvailabilityQueryOptions = (
  tenantId: string | null,
  params: SenderAvailabilityQuery,
  enabled = true
) => {
  const senderId = params.senderId?.trim();
  const sender = senderId ? undefined : params.sender?.trim();

  return queryOptions({
    queryKey: ['messaging/sender-availability', tenantId, params],
    queryFn: () =>
      MessagingSendersService.getSenderAvailability(
        params.channel,
        senderId,
        sender
      ),
    enabled: enabled && tenantId !== null && Boolean(senderId ?? sender),
  });
};
